import React from "react";
import { useTranslation } from "react-i18next";
import { CheckCircle } from "lucide-react";
import { Badge } from "../ui/badge";

const ImportResultStep = ({ importResult }) => {
  const { t } = useTranslation();

  return (
  <div className="space-y-4">
    <div className="bg-green-950/20 border border-green-900/40 rounded-lg p-6 text-center">
      <CheckCircle className="h-16 w-16 text-green-400 mx-auto mb-4" />
      <h3 className="text-2xl font-bold text-foreground mb-2">{t("importEmployees.result.title")}</h3>
      <p className="text-muted-foreground">
        {t("importEmployees.result.importedSuccess", { count: importResult.imported })}
      </p>
    </div>

    <div className="grid grid-cols-3 gap-4">
      <div className="bg-green-950/20 rounded-lg p-4 text-center">
        <p className="text-2xl font-bold text-green-400">{importResult.imported}</p>
        <p className="text-sm text-muted-foreground">{t("importEmployees.result.imported")}</p>
      </div>
      <div className="bg-yellow-950/20 rounded-lg p-4 text-center">
        <p className="text-2xl font-bold text-yellow-400">{importResult.skipped}</p>
        <p className="text-sm text-muted-foreground">{t("importEmployees.result.skipped")}</p>
      </div>
      <div className="bg-red-950/20 rounded-lg p-4 text-center">
        <p className="text-2xl font-bold text-red-400">{importResult.errors}</p>
        <p className="text-sm text-muted-foreground">{t("importEmployees.result.errors")}</p>
      </div>
    </div>

    {(importResult.skipped > 0 || importResult.errors > 0) && (
      <div className="max-h-64 overflow-y-auto border rounded-lg">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 sticky top-0">
            <tr>
              <th className="px-4 py-2 text-left">{t("importEmployees.table.line")}</th>
              <th className="px-4 py-2 text-left">{t("importEmployees.table.status")}</th>
              <th className="px-4 py-2 text-left">{t("importEmployees.table.reason")}</th>
            </tr>
          </thead>
          <tbody>
            {importResult.details
              .filter((d) => d.status !== "imported")
              .map((detail, index) => (
                <tr key={index} className="border-t">
                  <td className="px-4 py-2">{detail.line}</td>
                  <td className="px-4 py-2">
                    <Badge variant={detail.status === "error" ? "destructive" : "secondary"}>
                      {detail.status === "error" ? t("importEmployees.result.error") : t("importEmployees.result.skippedSingular")}
                    </Badge>
                  </td>
                  <td className="px-4 py-2 text-sm">{detail.reason}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
  );
};

export default ImportResultStep;
